(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 3236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(1047);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7940);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__);







var styles = (_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default());
var Dialog = function(param) {
    var title = param.title, description = param.description, opened = param.opened, dismissable = param.dismissable, type = param.type, inputs = param.inputs, enableTogglingKeypresses = param.enableTogglingKeypresses, confirmButtonName = param.confirmButtonName, cancelButtonName = param.cancelButtonName, className = param.className, descriptionHTML = param.descriptionHTML, onClose = param.onClose, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(opened), isOpen = ref[0], setIsOpen = ref[1];
    description = description || "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsOpen(opened);
        opened ? document.body.classList.add("dialog-opened") : document.body.classList.remove("dialog-opened");
        var handleKeypress = function(e) {
            if (enableTogglingKeypresses) {
                if (e.key == "Enter") {
                    handleClose(true, inputs);
                }
                if (e.key == "Escape") {
                    handleClose(false, {});
                }
                document.addEventListener("keydown", handleKeypress);
            }
        };
        if (enableTogglingKeypresses) {
            return function() {
                document.removeEventListener("keydown", handleKeypress);
            };
        }
    }, [
        opened
    ]);
    var parseMarkdownString = function(input) {
        var boldRegex = /\*\*(.*?)\*\*/g;
        var italicRegex = /\*(.*?)\*/g;
        var underlineRegex = /__(.*?)__/g;
        var result = input.replaceAll(boldRegex, "<b>$1</b>").replaceAll(italicRegex, "<em>$1</em>").replaceAll(underlineRegex, "<u>$1</u>");
        return result;
    };
    var parseMarkdown = function(input) {
        var joinedString = input.map(function(element) {
            return element.props.children;
        }).join("");
        var result = parseMarkdownString(joinedString);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            dangerouslySetInnerHTML: {
                __html: result
            }
        });
    };
    var descriptionLines = description.split("\n");
    var descriptionWithLineBreaks = descriptionLines.map(function(line, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                parseMarkdown([
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: line
                    })
                ]),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }, index);
    });
    var getConfirmationButtons = function() {
        switch(type){
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.INFO */ .i.INFO:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: cancelButtonName || "ОК"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.QUESTION */ .i.QUESTION:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Да"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Нет"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT */ .i.SUBMIT:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: confirmButtonName || "Отправить"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT_WITH_CANCEL */ .i.SUBMIT_WITH_CANCEL:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Отправить"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Отмена"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.NONE */ .i.NONE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
    };
    var handleClose = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(confirmed, inputs) {
            var ref, handlingResult, toClose;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onClose) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all([
                                onClose(confirmed, inputs || {})
                            ])
                        ];
                    case 1:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), handlingResult = ref[0];
                        toClose = handlingResult == undefined ? true : handlingResult;
                        if (toClose || !confirmed) {
                            setIsOpen(false);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setIsOpen(false);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClose(confirmed, inputs) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(styles.dialog).concat(className ? " " + className : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.content,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles["dialog-info"],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: title
                                }),
                                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: descriptionHTML ? "" : descriptionWithLineBreaks
                                }) : descriptionHTML ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: descriptionHTML
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            ]
                        }),
                        children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.actions,
                            children: getConfirmationButtons()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.overlay,
                    onClick: dismissable ? function() {
                        return handleClose(false, {});
                    } : undefined
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 1047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_misc_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1761);
/* harmony import */ var _components_Navbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(769);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(487);
/* harmony import */ var _lib_misc_utils_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6587);
/* harmony import */ var _lib_misc_validators__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6319);
/* harmony import */ var _components_Dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9500);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3366);
/* harmony import */ var _styles_Form_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7049);
/* harmony import */ var _styles_Form_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_Form_module_css__WEBPACK_IMPORTED_MODULE_11__);
















var styles = (_styles_Form_module_css__WEBPACK_IMPORTED_MODULE_11___default());
var Page = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), redirectTo = ref[0], setRedirectTo = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), register = ref1[0], setRegister = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), authCheckFailed = ref2[0], setAuthCheckFailed = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var _query = router.query, redirectTo = _query.redirectTo, register = _query.register, authCheckFailed = _query.authCheckFailed;
        setRedirectTo(redirectTo || "");
        setRegister(register === "true");
        setAuthCheckFailed(authCheckFailed === "true");
    }, [
        router.query
    ]);
    var defaultInputBorderStyle = (0,_lib_misc_utils_client__WEBPACK_IMPORTED_MODULE_8__/* .getBorderStyle */ .d)(3, "var(--default-input-border-color)");
    var errorInputBorderStyle = (0,_lib_misc_utils_client__WEBPACK_IMPORTED_MODULE_8__/* .getBorderStyle */ .d)(3, "var(--error-color)");
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), email = ref3[0], setEmail = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isEmailErrored = ref4[0], setIsEmailErrored = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), password = ref5[0], setPassword = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isPasswordErrored = ref6[0], setIsPasswordErrored = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isPasswordVisible = ref7[0], setIsPasswordVisible = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), rememberMe = ref8[0], setRememberMe = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), errorMessage = ref9[0], setErrorMessage = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), notice = ref10[0], setNotice = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), noticeDisplayed = ref11[0], setNoticeDisplayed = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), authCheckFailedMessageDisplayed = ref12[0], setAuthCheckFailedMessageDisplayed = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isLoginChecked = ref13[0], setIsLoginChecked = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isLoginProcessing = ref14[0], setIsLoginProcessing = ref14[1];
    // fields
    var handleEmailChange = function(e) {
        setEmail(e.target.value);
    };
    var handlePasswordChange = function(e) {
        setPassword(e.target.value);
    };
    // checkboxes
    var handleRememberMeChange = function(e) {
        setRememberMe(e.target.checked);
    };
    var handleShowPasswordChange = function(e) {
        setIsPasswordVisible(e.target.checked);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (true) {
            var accessToken = localStorage.getItem("accessToken");
            var handleRedirect = function() {
                if (redirectTo) {
                    if (redirectTo.includes("login")) {
                        return router.push({
                            pathname: "/login"
                        });
                    }
                    var query = {};
                    var queryParams = new URLSearchParams(new URL(location.origin + redirectTo).search);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = queryParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
                            query[key] = value;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return router.push({
                        pathname: "/".concat(redirectTo.split("?")[0]),
                        query: query
                    });
                }
                return router.push({
                    pathname: "/tests/created"
                });
            };
            if (accessToken) {
                (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
                    var accessToken, authResponce, authResult;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accessToken = localStorage.getItem("accessToken");
                                return [
                                    4,
                                    fetch("/api/v1/auth/verify?token=".concat(accessToken))
                                ];
                            case 1:
                                authResponce = _state.sent();
                                setIsLoginChecked(true);
                                if (!!authResponce.ok) return [
                                    3,
                                    2
                                ];
                                setIsPasswordErrored(true);
                                setErrorMessage("Не удалось проверить вход.");
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    authResponce.json()
                                ];
                            case 3:
                                authResult = _state.sent();
                                if (authResult.data.verified) {
                                    handleRedirect();
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    }, [
        isLoginChecked
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var wasNoticeDisplayed = localStorage.getItem("wasNoticeDisplayed");
        setNoticeDisplayed(register);
        if (register && noticeDisplayed && wasNoticeDisplayed !== "true") {
            setNotice("Аккаунт создан. Пожалуйста, активируйте аккаунт, пройдя по ссылке, " + "отправленной вам в письме на указанную при регистрации электронную почту. " + 'Если письма нет, проверьте папку "Спам", а так же убедитесь в правильности ' + "написание адреса вашего почтового ящика. После активации вы сможете войти в свой аккаунт.");
            localStorage.setItem("wasNoticeDisplayed", "true");
        }
    }, [
        register,
        noticeDisplayed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (redirectTo) {
            setNotice("Вы будете автоматически перенаправлены на запрашиваемую страницу сразу после входа в свой аккаунт.");
        }
    }, [
        redirectTo
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setAuthCheckFailedMessageDisplayed(authCheckFailed);
        if (authCheckFailed && authCheckFailedMessageDisplayed) {
            setIsPasswordErrored(true);
            setErrorMessage("Не удалось проверить вход.");
        }
    }, [
        authCheckFailed,
        authCheckFailedMessageDisplayed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var handleEnterKeypress = function(e) {
            if (e.key == "Enter") {
                handleLogin();
            }
        };
        document.addEventListener("keydown", handleEnterKeypress);
        return function() {
            document.removeEventListener("keydown", handleEnterKeypress);
        };
    });
    var handleLogin = function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            var passwordValidationOptions, isEmailOk, isPasswordOk, responce, result, query, queryParams, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, key, value;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nprogress__WEBPACK_IMPORTED_MODULE_4___default().start();
                        setIsLoginProcessing(true);
                        passwordValidationOptions = {
                            minLength: 6,
                            maxLength: 32
                        };
                        isEmailOk = (0,_lib_misc_validators__WEBPACK_IMPORTED_MODULE_15__/* .validateEmail */ .o)(email);
                        isPasswordOk = (0,_lib_misc_validators__WEBPACK_IMPORTED_MODULE_15__/* .validateString */ .C)(password, passwordValidationOptions);
                        setNotice("");
                        setErrorMessage("");
                        setIsEmailErrored(false);
                        setIsPasswordErrored(false);
                        if (!email) {
                            setErrorMessage("Укажите почту.");
                            return [
                                2,
                                setIsEmailErrored(true)
                            ];
                        }
                        if (!isEmailOk) {
                            setErrorMessage("Указана неправильная почта.");
                            return [
                                2,
                                setIsEmailErrored(true)
                            ];
                        }
                        if (!password) {
                            setErrorMessage("Укажите пароль.");
                            return [
                                2,
                                setIsPasswordErrored(true)
                            ];
                        }
                        if (!isPasswordOk) {
                            setErrorMessage("Пароль должен быть от ".concat(passwordValidationOptions.minLength, " до ") + "".concat(passwordValidationOptions.maxLength, " символов в длину."));
                            return [
                                2,
                                setIsPasswordErrored(true)
                            ];
                        }
                        return [
                            4,
                            fetch("/api/v1/auth/login", {
                                method: "POST",
                                body: JSON.stringify({
                                    email: email,
                                    password: password,
                                    rememberMe: rememberMe
                                })
                            })
                        ];
                    case 1:
                        responce = _state.sent();
                        if (!responce.ok) {
                            setIsPasswordErrored(true);
                            switch(responce.status){
                                case 403:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Неверные данные для входа.")
                                        ];
                                    }
                                case 406:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Аккаунт не активирован.")
                                        ];
                                    }
                                case 429:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Вы отправляете слишком много запросов.")
                                        ];
                                    }
                                default:
                                    return [
                                        2,
                                        setErrorMessage("Сервер авторизации недоступен.")
                                    ];
                            }
                        }
                        return [
                            4,
                            responce.json()
                        ];
                    case 2:
                        result = _state.sent();
                        localStorage.setItem("accessToken", result.data.accessToken);
                        localStorage.setItem("user", JSON.stringify(result.data.payload));
                        if (redirectTo) {
                            query = {};
                            queryParams = new URLSearchParams(new URL(location.origin + redirectTo).search);
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = queryParams.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_step.value, 2), key = _value[0], value = _value[1];
                                    query[key] = value;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                2,
                                router.push({
                                    pathname: "".concat((redirectTo.startsWith("/") ? redirectTo : "/" + redirectTo).split("?")[0]),
                                    query: query
                                })
                            ];
                        }
                        return [
                            2,
                            router.push({
                                pathname: "/tests/created"
                            })
                        ];
                }
            });
        })().then(function() {
            setIsLoginProcessing(false);
            nprogress__WEBPACK_IMPORTED_MODULE_4___default().done();
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: styles.main,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                        className: styles.title,
                        children: [
                            "Вход в ",
                            _lib_misc_constants__WEBPACK_IMPORTED_MODULE_5__/* .APP_NAME */ .iC
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: styles.form,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: styles.label,
                                        style: {
                                            color: isEmailErrored ? "var(--error-color)" : "white"
                                        },
                                        children: "Электронная почта"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: styles.input,
                                        type: "email",
                                        onChange: handleEmailChange,
                                        style: {
                                            border: isEmailErrored ? errorInputBorderStyle : defaultInputBorderStyle
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: styles.label,
                                        style: {
                                            color: isPasswordErrored ? "var(--error-color)" : "white"
                                        },
                                        children: "Пароль"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        className: styles.input,
                                        type: isPasswordVisible ? "text" : "password",
                                        onChange: handlePasswordChange,
                                        style: {
                                            border: isPasswordErrored ? errorInputBorderStyle : defaultInputBorderStyle
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: styles.checkboxes,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: styles["checkbox-container"],
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "checkbox",
                                                name: "showPassword",
                                                id: "showPassword",
                                                checked: isPasswordVisible,
                                                onChange: handleShowPasswordChange
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: styles.label,
                                                htmlFor: "showPassword",
                                                children: "Показать пароль"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: styles["checkbox-container"],
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "checkbox",
                                                name: "remember",
                                                id: "remember",
                                                checked: rememberMe,
                                                onChange: handleRememberMeChange
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: styles.label,
                                                htmlFor: "remember",
                                                children: "Запомнить меня"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            notice && register && noticeDisplayed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                title: "Спасибо за регистрацию!",
                                description: notice,
                                opened: register && noticeDisplayed,
                                dismissable: true,
                                type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__/* .DialogType.INFO */ .i.INFO
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: styles.notice,
                                style: {
                                    display: notice ? "block" : "none"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    style: {
                                        marginTop: notice.length < 100 ? 15 : 0
                                    },
                                    children: notice
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: styles.error,
                                style: {
                                    display: errorMessage ? "block" : "none"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: errorMessage
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "#",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "".concat(styles.button).concat(isLoginProcessing ? " " + styles.processing : ""),
                                    onClick: isLoginProcessing ? undefined : handleLogin,
                                    children: isLoginProcessing ? "Входим..." : "Вход"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/requestPasswordReset",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: styles.link,
                                    children: "Забыли пароль?"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Нет аккаунта?",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/register",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: styles.link,
                                    children: "Зарегистрируйтесь"
                                })
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DialogType; }
/* harmony export */ });
var DialogType;
(function(DialogType) {
    DialogType[DialogType["INFO"] = 0] = "INFO";
    DialogType[DialogType["QUESTION"] = 1] = "QUESTION";
    DialogType[DialogType["SUBMIT"] = 2] = "SUBMIT";
    DialogType[DialogType["SUBMIT_WITH_CANCEL"] = 3] = "SUBMIT_WITH_CANCEL";
    DialogType[DialogType["NONE"] = 4] = "NONE";
})(DialogType || (DialogType = {}));


/***/ }),

/***/ 7940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__THu6o","content":"Dialog_content__t2syO","dialog-info":"Dialog_dialog-info__j1_UR","actions":"Dialog_actions__xMAgR","overlay":"Dialog_overlay__Hu_IV","submit-button":"Dialog_submit-button__SVCAU","processing":"Dialog_processing__YZfAM","cancel-button":"Dialog_cancel-button__d8uJf","dialog-close":"Dialog_dialog-close__mHTeh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,714,106,231,505,774,888,179], function() { return __webpack_exec__(3236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);